import React from "react";
import { AlertTriangle, Phone, ExternalLink, X } from "lucide-react";

export default function CrisisBanner({ onClose }) {
    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center px-4 bg-black/85 backdrop-blur-sm"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="crisis-title"
            data-testid="crisis-banner"
        >
            <div className="relative w-full max-w-2xl border-4 border-[var(--warning)] bg-[#0d0d0d] text-[var(--paper-2)] shadow-[10px_10px_0_var(--danger)]">
                <div className="hazard-stripes h-3" />
                <div className="p-8 md:p-10">
                    <div className="flex items-start gap-4 mb-6">
                        <AlertTriangle className="w-12 h-12 text-[var(--warning)] flex-shrink-0" />
                        <div>
                            <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-[var(--warning)] mb-2">
                                Alto · señal de emergencia
                            </p>
                            <h2
                                id="crisis-title"
                                className="font-display text-3xl md:text-4xl leading-[0.95]"
                            >
                                Lo que escribiste suena a más que un ejercicio.
                            </h2>
                        </div>
                    </div>
                    <p className="font-mono text-sm md:text-base text-[var(--paper)] leading-relaxed mb-4">
                        Si estás pensando en hacerte daño, no estás solo y no
                        tienes que resolver esto en silencio. Detén el ejercicio
                        y habla con alguien <strong>ahora</strong>.
                    </p>
                    <p className="font-mono text-xs text-[var(--ink-muted)] mb-6">
                        Estas líneas son gratuitas, confidenciales y atienden
                        las 24 horas.
                    </p>

                    <div className="grid sm:grid-cols-2 gap-3 mb-6">
                        <a
                            href="tel:6003607777"
                            className="flex items-center gap-3 border-2 border-[var(--danger)] bg-[var(--danger)] text-[var(--paper-2)] px-4 py-3 hover:bg-transparent hover:text-[var(--danger)] transition-colors"
                            data-testid="crisis-call-saludresponde"
                        >
                            <Phone className="w-4 h-4" />
                            <div>
                                <p className="font-mono text-[10px] uppercase tracking-[0.25em] opacity-80">
                                    Salud Responde (Chile)
                                </p>
                                <p className="font-display text-xl leading-none">
                                    600 360 7777
                                </p>
                            </div>
                        </a>
                        <a
                            href="tel:4141"
                            className="flex items-center gap-3 border-2 border-[var(--warning)] text-[var(--warning)] px-4 py-3 hover:bg-[var(--warning)] hover:text-black transition-colors"
                            data-testid="crisis-call-suicide"
                        >
                            <Phone className="w-4 h-4" />
                            <div>
                                <p className="font-mono text-[10px] uppercase tracking-[0.25em] opacity-80">
                                    Línea Prev. Suicidio
                                </p>
                                <p className="font-display text-xl leading-none">
                                    *4141
                                </p>
                            </div>
                        </a>
                    </div>

                    <div className="flex flex-wrap gap-3 pt-6 border-t border-dashed border-[var(--ink-dim)]">
                        <a
                            href="/salida"
                            className="btn-brutal btn-brutal-danger"
                            data-testid="crisis-go-salida"
                        >
                            Ir a Salida de emergencia
                            <ExternalLink className="w-4 h-4" />
                        </a>
                        <button
                            onClick={onClose}
                            className="btn-brutal btn-brutal-ghost"
                            data-testid="crisis-continue"
                        >
                            Entiendo · seguir con cuidado
                        </button>
                    </div>
                </div>
                <button
                    onClick={onClose}
                    aria-label="Cerrar"
                    className="absolute top-3 right-3 p-2 text-[var(--ink-muted)] hover:text-[var(--paper-2)]"
                    data-testid="crisis-close"
                >
                    <X className="w-4 h-4" />
                </button>
                <div className="hazard-stripes h-3" />
            </div>
        </div>
    );
}
